// icons
import TableOutlined from '@ant-design/icons/TableOutlined';

// ==============================|| TEST TABLE MENU ITEM ||============================== //

const testTable = {
  id: 'test-table',
  title: 'Test Table',
  type: 'item',
  url: '/test-table',
  icon: TableOutlined,
  breadcrumbs: false,
  permission: {
    module: 'test_table',
    level: 10
  }
};

export default testTable;
